import type { Conversation } from "./types";


export function contactName(conversation: Conversation): string {
  return conversation.display_name.trim() || conversation.wa_id;
}

export function initials(name: string): string {
  const clean = name.trim();
  if (!clean) return "?";
  const parts = clean.split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function formatListTime(value: string | null): string {
  if (!value) return "";
  const date = new Date(value);
  const today = new Date();
  if (date.toDateString() === today.toDateString()) {
    return new Intl.DateTimeFormat("it-IT", {
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
  }
  return new Intl.DateTimeFormat("it-IT", {
    day: "2-digit",
    month: "2-digit",
  }).format(date);
}

export function formatMessageTime(value: string): string {
  return new Intl.DateTimeFormat("it-IT", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

export function formatFullDate(value: string): string {
  return new Intl.DateTimeFormat("it-IT", {
    weekday: "long",
    day: "numeric",
    month: "long",
  }).format(new Date(value));
}

export function dateKey(value: string): string {
  return new Date(value).toDateString();
}

export function formatBytes(value: number | null): string {
  if (value === null) return "";
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
  return `${(value / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatFlowMessage(value: string): string {
  const prefix = "[Flow]";
  if (!value.startsWith(prefix)) return value;

  const payload = value.slice(prefix.length).trim();
  if (!payload) return value;

  try {
    return `${prefix}\n${JSON.stringify(JSON.parse(payload), null, 2)}`;
  } catch {
    return value;
  }
}

export function messagePreview(conversation: Conversation): string {
  const message = conversation.latest_message;
  if (!message) return "Nessun messaggio";
  if (message.text) return message.text;
  const labels: Record<string, string> = {
    audio: "Messaggio vocale",
    image: "Immagine",
    video: "Video",
    document: "Documento",
    sticker: "Sticker",
    interactive: "Messaggio interattivo",
  };
  return labels[message.message_type] || "Messaggio";
}
